/* --- Argatronics Sale Logic --- */
(function() {
  function markSaleCards() {
    const wrappers = document.querySelectorAll('.card, .product-card, .product-card-wrapper');
    wrappers.forEach(wrapper => {
      const hasSale = wrapper.querySelector('.compare-at-price, .price__compare, s');
      if (hasSale) {
        wrapper.classList.add('is-on-sale');
        let media = wrapper.querySelector('a.contents, .card__media, a[href*="/products/"]');
        if (media) media.classList.add('sale-media');
      }
    });
  }

  // Ejecutar al cargar y tras cambios en el DOM (filtros, paginación)
  document.addEventListener('DOMContentLoaded', markSaleCards);
  document.addEventListener('shopify:section:load', markSaleCards);
  
  const observer = new MutationObserver(markSaleCards);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Colecciones: neutraliza estilos globales pegados en descripciones RTE
(function() {
  function sanitizeCollectionRteStyles() {
    if (!document.querySelector('.collection-hero')) return;

    document.querySelectorAll('main rte-formatter').forEach(function(formatter) {
      formatter.querySelectorAll('meta, title').forEach(function(node) {
        node.remove();
      });

      formatter.querySelectorAll('style').forEach(function(styleTag) {
        const original = styleTag.textContent || '';
        if (!/(^|\W)\*\s*\{|(^|\W)(html|body)\s*\{/m.test(original)) return;

        const sanitized = original
          .replace(/(^|})\s*\*\s*\{[^}]*\}/gm, '$1')
          .replace(/(^|})\s*(html|body)\s*\{[^}]*\}/gm, '$1')
          .replace(/\n{3,}/g, '\n\n')
          .trim();

        if (sanitized) {
          styleTag.textContent = sanitized;
        } else {
          styleTag.remove();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', sanitizeCollectionRteStyles);
  document.addEventListener('shopify:section:load', sanitizeCollectionRteStyles);
})();

// Fix: forzar return_to limpio en formularios de localización
(function() {
  function fixLocalizationForms() {
    const forms = document.querySelectorAll('form.localization-form');
    forms.forEach(function(form) {
      if (form.dataset.returnToFixed) return;
      form.dataset.returnToFixed = 'true';

      // Eliminar cualquier return_to existente
      const existing = form.querySelector('input[name="return_to"]');
      if (existing) existing.remove();

      // Añadir return_to con la URL limpia (sin section_id ni otros params de sección)
      form.addEventListener('submit', function() {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('section_id');

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        input.value = cleanUrl.pathname + (cleanUrl.search || '');
        form.appendChild(input);
      }, true);
    });
  }

  // Sobrescribir también form.submit() programático
  const originalSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function() {
    if (this.classList.contains('localization-form')) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('section_id');

      let input = this.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        this.appendChild(input);
      }
      input.value = cleanUrl.pathname + (cleanUrl.search || '');
    }
    originalSubmit.call(this);
  };

  document.addEventListener('DOMContentLoaded', fixLocalizationForms);
  document.addEventListener('shopify:section:load', fixLocalizationForms);
})();

(function() {
  function labelJudgeMeCarouselArrows(root) {
    const scope = root instanceof Element || root instanceof Document ? root : document;

    scope.querySelectorAll('button.jdgm-arrow').forEach(function(button) {
      const onClick = button.getAttribute('onclick') || '';
      let label = '';

      if (/jdgmPreviousCard/i.test(onClick) || button.classList.contains('jdgm-prev')) {
        label = 'Testimonio anterior';
      } else if (/jdgmNextCard/i.test(onClick) || button.classList.contains('jdgm-next')) {
        label = 'Testimonio siguiente';
      }

      if (!label) return;

      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function observeJudgeMeArrows() {
    labelJudgeMeCarouselArrows(document);

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!(node instanceof Element)) return;

          if (node.matches('.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-arrows--bottom, button.jdgm-arrow')) {
            labelJudgeMeCarouselArrows(node);
            return;
          }

          if (node.querySelector('.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-arrows--bottom, button.jdgm-arrow')) {
            labelJudgeMeCarouselArrows(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', observeJudgeMeArrows);
  document.addEventListener('shopify:section:load', function(event) {
    labelJudgeMeCarouselArrows(event.target instanceof Element ? event.target : document);
  });
})();
// Sticky header: gestionado por CSS (argatronics-custom.css)